import React from 'react';
export function About() {
  return <section id="about" className="py-20 bg-white border-b border-gray-100" data-id="element-34">
      <div className="container mx-auto px-4" data-id="element-35">
        <div className="text-center mb-16" data-id="element-36">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-37">
            Why Swedenmark AI
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-purple-500 mx-auto rounded-full" data-id="element-38"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-16 items-start" data-id="element-39">
          <div className="space-y-8" data-id="element-40">
            <div data-id="element-41">
              <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-42">
                Built around your business,{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500" data-id="element-43">
                  not the generic tool everyone gets.
                </span>
              </h3>
              <p className="text-gray-600 text-lg leading-relaxed" data-id="element-44">
                Most people know AI matters but haven't put it to work. We make
                it concrete: we look at where business is slipping through the
                cracks — after-hours calls, leads you get to too late, quotes
                nobody chases — and where repetitive work eats your team's week.
                Then we build AI in around how you actually run, so it fits,
                gets used, and you can measure it.
              </p>
            </div>

            <p className="text-gray-600 text-lg leading-relaxed" data-id="element-45">
              We're operators who ship, not an agency reselling the same
              platform to everyone. We find the two or three spots where it'll
              pay off fastest, put measurement in from the start, and stay close
              enough to keep it improving after launch.
            </p>

            <div className="grid sm:grid-cols-3 gap-4 pt-2" data-id="element-46">
              <div className="bg-gray-50 border border-gray-100 rounded-lg p-4" data-id="element-47">
                <div className="text-xs font-semibold uppercase tracking-wider text-blue-600 mb-1" data-id="element-48">
                  Built to fit
                </div>
                <p className="text-sm text-gray-600 leading-snug" data-id="element-49">
                  Shaped around how your business actually runs
                </p>
              </div>
              <div className="bg-gray-50 border border-gray-100 rounded-lg p-4" data-id="element-50">
                <div className="text-xs font-semibold uppercase tracking-wider text-blue-600 mb-1" data-id="element-51">
                  Measured
                </div>
                <p className="text-sm text-gray-600 leading-snug" data-id="element-52">
                  You see what it's producing from day one
                </p>
              </div>
              <div className="bg-gray-50 border border-gray-100 rounded-lg p-4" data-id="element-53">
                <div className="text-xs font-semibold uppercase tracking-wider text-purple-600 mb-1" data-id="element-54">
                  On the hook
                </div>
                <p className="text-sm text-gray-600 leading-snug" data-id="element-55">
                  We can tie part of our fee to the results
                </p>
              </div>
            </div>

            <div className="border-l-4 border-l-blue-500 pl-6 py-2 bg-gradient-to-r from-blue-50/50 to-purple-50/50 rounded-r-lg" data-id="element-56">
              <blockquote className="text-xl font-medium text-gray-900 italic" data-id="element-57">
                "We find where AI would earn its keep fastest in your business —
                and build it in."
              </blockquote>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4" data-id="element-58">
            <div className="aspect-square bg-gray-100 rounded-lg overflow-hidden" data-id="element-59">
              <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Analytics dashboard with performance metrics" className="w-full h-full object-cover" data-id="element-60" />
            </div>
            <div className="aspect-square bg-gray-100 rounded-lg overflow-hidden mt-8" data-id="element-61">
              <img src="https://images.unsplash.com/photo-1531297484001-80022131f5a1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Sleek automation workspace" className="w-full h-full object-cover" data-id="element-62" />
            </div>
            <div className="aspect-square bg-gray-100 rounded-lg overflow-hidden" data-id="element-63">
              <img src="https://images.unsplash.com/photo-1518770660439-4636190af475?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Abstract data and automation patterns" className="w-full h-full object-cover" data-id="element-64" />
            </div>
            <div className="aspect-square bg-gray-100 rounded-lg overflow-hidden mt-8" data-id="element-65">
              <img src="https://images.unsplash.com/photo-1518186285589-2f7649de83e0?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Sleek automation and modern technology" className="w-full h-full object-cover" data-id="element-66" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}